import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de65ccc9e69352/components/sections/BranchSolutionsShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de65ccc9e69352/components/sections/ClientShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/tmp/8de65ccc9e69352/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de65ccc9e69352/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de65ccc9e69352/components/sections/UseCasesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/app/[locale]/industries/shared-branch.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/node_modules/next/dist/client/link.js");
